__turbopack_context__.v({
  "pill": "P457IW_pill",
});
